import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Section, CountdownTimer, CTAButton } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" className="bg-brand-surface/20 rounded-3xl my-12" data-id="element-275">
      <div className="text-center mb-10" data-id="element-276">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-gold mb-6" data-id="element-277">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <CountdownTimer data-id="element-278" />
      </div>

      <div className="max-w-md mx-auto mb-12" data-id="element-279"></div>

      <h3 className="text-3xl font-serif font-bold text-center mb-10" data-id="element-280">
        ELEGÍ TU PACK
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-281">
        {/* Basic Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-text/10 hover:border-brand-gold/30 transition-colors" data-id="element-282">
          <div className="mb-6" data-id="element-283">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center" data-id="element-284">
              🌿 MÉTODO BORRÓN Y CUENTA NUEVA
            </h4>
            <p className="text-brand-gold font-medium" data-id="element-285">6 Tomos + 2 Bonus</p>
          </div>

          <div className="bg-brand-surfaceLight/50 p-4 rounded-xl mb-6 text-sm text-brand-text/80" data-id="element-286">
            <span className="font-bold text-[#F5D061]" data-id="element-287">Ideal para:</span>{' '}
            Mujeres que quieren sanar su campo emocional y avanzar a su próxima
            etapa
          </div>

          <div className="mb-8" data-id="element-288">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-289">
              $40.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-290">
              $19.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-291">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-292">
            <CTAButton fullWidth className="text-base py-4 bg-brand-surfaceLight text-brand-text border border-brand-gold/30 hover:bg-brand-surfaceLight/80" href="https://www.lumenakasha.com/cart/46660716232893:1" data-id="element-293">
              → QUIERO MI MÉTODO AHORA
            </CTAButton>
          </div>
        </div>

        {/* Premium Tier */}
        <div className="glass-panel rounded-3xl p-8 flex flex-col border-brand-gold relative transform lg:-translate-y-4 shadow-[0_0_40px_rgba(212,175,55,0.15)]" data-id="element-294">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-dark font-bold px-4 py-1 rounded-full text-sm flex items-center shadow-lg" data-id="element-295">
            <Star className="w-4 h-4 mr-1 fill-current" data-id="element-296" /> MÁS ELEGIDO
          </div>

          <div className="mb-6 mt-2" data-id="element-297">
            <h4 className="text-2xl font-serif font-bold mb-2 flex items-center text-brand-text" data-id="element-298">
              🌟 MÉTODO + BITÁCORA DE 21 DÍAS
            </h4>
            <p className="text-brand-gold/80 font-medium" data-id="element-299">
              6 Tomos + 2 Bonus + Guía de Implementación Completa
            </p>
          </div>

          <div className="bg-brand-gold/10 p-4 rounded-xl mb-6 text-sm text-brand-text/90 border border-brand-gold/20" data-id="element-300">
            <span className="font-bold text-brand-gold" data-id="element-301">Ideal para:</span>{' '}
            Mujeres que quieren resultados acelerados con una hoja de ruta
            diaria
          </div>

          <div className="mb-8" data-id="element-302">
            <div className="text-brand-text/50 line-through text-xl mb-1" data-id="element-303">
              $55.000
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-304">
              $27.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-305">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-306">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46660719182013:1" data-id="element-307">
              → QUIERO EL PACK COMPLETO
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 mt-12 text-sm text-brand-muted flex-row items-start justify-center" data-id="element-308">
        <div className="flex items-center" data-id="element-309">
          <Lock className="w-4 h-4 mr-2" data-id="element-310" /> Pago 100% seguro
        </div>
        <div className="flex items-center" data-id="element-311">
          <Zap className="w-4 h-4 mr-2" data-id="element-312" /> Acceso en 5 minutos
        </div>
        <div className="flex items-center" data-id="element-313">
          <Shield className="w-4 h-4 mr-2" data-id="element-314" /> Garantía 7 días
        </div>
        <div className="flex items-center" data-id="element-315">
          <CreditCard className="w-4 h-4 mr-2" data-id="element-316" /> Mercado Pago · Tarjeta ·
          Transferencia
        </div>
      </div>
    </Section>;
};